export function BrandMark({ compact = false }: { compact?: boolean }) {
  return (
    <span aria-label="회독루프" className="pn-brand">
      <svg aria-hidden className="pn-brand__mark" viewBox="0 0 64 64">
        <rect className="pn-brand__page" height="48" rx="12" width="44" x="8" y="8" />
        <path className="pn-brand__binding" d="M17 9v46" />
        <path className="pn-brand__line" d="M24 24h19M24 33h19M24 42h13" />
        <path className="pn-brand__stem" d="M43 20c2-6 5-10 11-13" />
        <path className="pn-brand__leaf" d="M42 18C41 10 46 5 57 6c0 9-5 14-15 12Z" />
      </svg>
      {compact ? null : (
        <strong>
          회독<span>루프</span>
        </strong>
      )}
    </span>
  );
}
